/* ==========================================================================
   NUVI KIDZ WORLD — mini-games. Original, lightweight and offline-friendly.
   No ads, no accounts, no tracking, nothing stored about the child.
   Every game is played with taps or the keyboard (buttons), and every
   answer is announced in a polite live region for screen readers.
   Loaded only on pages with the "World mini-games" section.
   ========================================================================== */
(function () {
  'use strict';

  function rand(n) { return Math.floor(Math.random() * n); }
  function shuffle(list) {
    var a = list.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = rand(i + 1); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function sample(list, n) { return shuffle(list).slice(0, n); }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] != null) e.setAttribute(k, attrs[k]); });
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function flash(btn, ok) {
    var cls = ok ? 'is-ok' : 'is-no';
    btn.classList.remove('is-ok', 'is-no'); void btn.offsetWidth; btn.classList.add(cls);
  }

  /* ---------- shared pictures ---------- */
  var COLOURS = [
    ['red', '#D9534F'], ['yellow', '#EAB83D'], ['green', '#6E8B4E'], ['blue', '#4F86B0'],
    ['orange', '#E8894B'], ['purple', '#8B6BAE'], ['pink', '#E58CA6'], ['brown', '#8A6248']
  ];
  var SHAPES = {
    circle: '<circle cx="50" cy="50" r="38"/>',
    square: '<rect x="14" y="14" width="72" height="72" rx="6"/>',
    triangle: '<path d="M50 12 90 86H10z"/>',
    star: '<path d="m50 8 12 27 29 3-22 20 7 29-26-15-26 15 7-29L9 38l29-3z"/>',
    heart: '<path d="M50 86S10 62 10 34a20 20 0 0 1 40-6 20 20 0 0 1 40 6c0 28-40 52-40 52z"/>',
    rectangle: '<rect x="8" y="26" width="84" height="48" rx="6"/>',
    oval: '<ellipse cx="50" cy="50" rx="42" ry="28"/>',
    diamond: '<path d="M50 8 88 50 50 92 12 50z"/>'
  };
  function shapeSvg(name, fill) {
    return '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false"><g fill="' + (fill || '#9AA38C') + '">' + SHAPES[name] + '</g></svg>';
  }
  var ANIMALS = [
    { name: 'cow', emoji: '🐄', sound: 'Moo' }, { name: 'dog', emoji: '🐶', sound: 'Woof woof' },
    { name: 'cat', emoji: '🐱', sound: 'Meow' }, { name: 'duck', emoji: '🦆', sound: 'Quack quack' },
    { name: 'sheep', emoji: '🐑', sound: 'Baa' }, { name: 'lion', emoji: '🦁', sound: 'Roar' },
    { name: 'rooster', emoji: '🐓', sound: 'Cock-a-doodle-doo' }, { name: 'horse', emoji: '🐴', sound: 'Neigh' },
    { name: 'pig', emoji: '🐷', sound: 'Oink oink' }, { name: 'frog', emoji: '🐸', sound: 'Ribbit' },
    { name: 'owl', emoji: '🦉', sound: 'Hoo hoo' }, { name: 'bee', emoji: '🐝', sound: 'Buzz' }
  ];
  var LETTERS = [
    ['A', 'apple', '🍎'], ['B', 'ball', '⚽'], ['C', 'cat', '🐱'], ['D', 'duck', '🦆'], ['E', 'elephant', '🐘'],
    ['F', 'fish', '🐟'], ['G', 'grapes', '🍇'], ['H', 'hat', '🎩'], ['I', 'ice cream', '🍦'], ['J', 'juice', '🧃'],
    ['K', 'kite', '🪁'], ['L', 'leaf', '🍃'], ['M', 'moon', '🌙'], ['N', 'nest', '🪺'], ['O', 'orange', '🍊'],
    ['P', 'pear', '🍐'], ['Q', 'queen', '👑'], ['R', 'rainbow', '🌈'], ['S', 'sun', '☀️'], ['T', 'tree', '🌳'],
    ['U', 'umbrella', '☂️'], ['V', 'van', '🚐'], ['W', 'whale', '🐳'], ['X', 'xylophone', '🎼'], ['Y', 'yo-yo', '🪀'], ['Z', 'zebra', '🦓']
  ];
  var GROUPS = {
    fruit: ['🍎', '🍌', '🍇', '🍐', '🍊', '🍓', '🍉'],
    animals: ['🐶', '🐱', '🐰', '🐻', '🐸', '🐵', '🐘'],
    vehicles: ['🚗', '🚌', '🚲', '🚂', '✈️', '🚤', '🚜'],
    weather: ['☀️', '🌧️', '⛄', '🌈', '☁️', '⚡'],
    clothes: ['👕', '👖', '🧦', '🧢', '👗', '🧤']
  };
  var GROUP_NAMES = { fruit: 'fruit', animals: 'animals', vehicles: 'things that go', weather: 'weather', clothes: 'clothes' };
  var SEQUENCES = [
    { title: 'Plant a seed', steps: [['🌰', 'Seed'], ['🌱', 'Sprout'], ['🌿', 'Plant'], ['🌻', 'Flower']] },
    { title: 'Bath time', steps: [['🛁', 'Fill the bath'], ['🧼', 'Wash'], ['🧺', 'Dry with a towel'], ['👕', 'Get dressed']] },
    { title: 'Make a sandwich', steps: [['🍞', 'Bread'], ['🧈', 'Spread'], ['🥒', 'Filling'], ['🥪', 'Eat']] },
    { title: 'A day', steps: [['🌅', 'Morning'], ['☀️', 'Afternoon'], ['🌇', 'Evening'], ['🌙', 'Night']] },
    { title: 'A butterfly grows', steps: [['🥚', 'Egg'], ['🐛', 'Caterpillar'], ['🟤', 'Cocoon'], ['🦋', 'Butterfly']] },
    { title: 'Snowman', steps: [['⚪', 'Roll a big ball'], ['⚪', 'Add a smaller ball'], ['🥕', 'Add a nose'], ['⛄', 'Done!']] }
  ];

  function speak(text) {
    try {
      if (!('speechSynthesis' in window)) return false;
      window.speechSynthesis.cancel();
      var u = new SpeechSynthesisUtterance(text);
      u.rate = 0.85; u.pitch = 1.1;
      window.speechSynthesis.speak(u);
      return true;
    } catch (e) { return false; }
  }

  /* ---------- games: each builds into `play` and reports via `ui` ---------- */
  var GAMES = {};

  GAMES['color-match'] = function (play, ui) {
    function round() {
      var pick = sample(COLOURS, 4), target = pick[rand(4)];
      play.innerHTML = '<p class="nkw-play__prompt">Find <span>' + target[0] + '</span> <span class="nkw-dot" style="background:' + target[1] + '" aria-hidden="true"></span></p>';
      var grid = el('div', { class: 'nkw-play__grid' });
      pick.forEach(function (c) {
        var b = el('button', { type: 'button', class: 'nkw-tile', style: 'background:' + c[1], 'aria-label': c[0] });
        b.addEventListener('click', function () {
          if (c[0] === target[0]) { flash(b, true); ui.win('Yes! That is ' + c[0] + '.'); setTimeout(round, 900); }
          else { flash(b, false); ui.say('That one is ' + c[0] + '. Try again!'); }
        });
        grid.appendChild(b);
      });
      play.appendChild(grid);
    }
    round();
  };

  GAMES['shape-explorer'] = function (play, ui) {
    var names = Object.keys(SHAPES);
    function round() {
      var pick = sample(names, 4), target = pick[rand(4)];
      play.innerHTML = '<p class="nkw-play__prompt">Find the ' + target + '</p>';
      var grid = el('div', { class: 'nkw-play__grid' });
      var fills = shuffle(['#9AA38C', '#F2B49A', '#EAB83D', '#4F86B0']);
      pick.forEach(function (n, i) {
        var b = el('button', { type: 'button', class: 'nkw-tile', 'aria-label': n }, shapeSvg(n, fills[i]));
        b.addEventListener('click', function () {
          if (n === target) { flash(b, true); ui.win('Well done! That is a ' + n + '.'); setTimeout(round, 900); }
          else { flash(b, false); ui.say('That is a ' + n + '. Look for the ' + target + '.'); }
        });
        grid.appendChild(b);
      });
      play.appendChild(grid);
    }
    round();
  };

  GAMES['memory-match'] = function (play, ui) {
    var faces = sample(GROUPS.animals.concat(GROUPS.fruit), 6);
    var deck = shuffle(faces.concat(faces));
    var open = [], found = 0, moves = 0, lock = false;
    play.innerHTML = '<p class="nkw-play__prompt">Turn over two cards to find a pair</p>';
    var grid = el('div', { class: 'nkw-play__grid', style: '--cols:4' });
    deck.forEach(function (face, i) {
      var b = el('button', { type: 'button', class: 'nkw-tile is-hidden', 'aria-label': 'Card ' + (i + 1) + ', face down' }, '<span>' + face + '</span>');
      b.addEventListener('click', function () {
        if (lock || !b.classList.contains('is-hidden')) return;
        b.classList.remove('is-hidden'); b.setAttribute('aria-label', 'Card ' + (i + 1) + ', ' + face);
        open.push({ b: b, face: face, i: i });
        if (open.length === 2) {
          moves++; lock = true;
          var a = open[0], c = open[1];
          if (a.face === c.face) {
            [a.b, c.b].forEach(function (x) { x.classList.add('is-matched'); x.disabled = true; });
            found++; open = []; lock = false;
            if (found === faces.length) ui.win('You found all the pairs in ' + moves + ' turns!');
            else ui.say('A pair! ' + (faces.length - found) + ' to go.');
          } else {
            ui.say('Not a pair. Remember where they are!');
            setTimeout(function () {
              [a, c].forEach(function (x) { x.b.classList.add('is-hidden'); x.b.setAttribute('aria-label', 'Card ' + (x.i + 1) + ', face down'); });
              open = []; lock = false;
            }, 900);
          }
        }
      });
      grid.appendChild(b);
    });
    play.appendChild(grid);
  };

  GAMES['counting-fun'] = function (play, ui) {
    var things = ['🍎', '⭐', '🐟', '🎈', '🌸', '🐞'];
    function round() {
      var n = 1 + rand(10), thing = things[rand(things.length)];
      var opts = shuffle([n].concat(sample([1, 2, 3, 4, 5, 6, 7, 8, 9, 10].filter(function (x) { return x !== n; }), 2)));
      play.innerHTML = '<p class="nkw-play__prompt">How many can you count?</p>' +
        '<div class="nkw-play__row" role="img" aria-label="' + n + ' pictures" style="font-size:34px;justify-content:center">' + new Array(n + 1).join('<span aria-hidden="true">' + thing + '</span>') + '</div>';
      var grid = el('div', { class: 'nkw-play__grid', style: '--cols:3' });
      opts.forEach(function (o) {
        var b = el('button', { type: 'button', class: 'nkw-tile' }, String(o));
        b.addEventListener('click', function () {
          if (o === n) { flash(b, true); ui.win('Yes, ' + n + '!'); setTimeout(round, 900); }
          else { flash(b, false); ui.say('Not quite. Touch each one as you count.'); }
        });
        grid.appendChild(b);
      });
      play.appendChild(grid);
    }
    round();
  };

  GAMES['animal-sounds'] = function (play, ui) {
    function round() {
      var pick = sample(ANIMALS, 3), target = pick[rand(3)];
      play.innerHTML = '<p class="nkw-play__prompt">Who says "' + esc(target.sound) + '"?</p>';
      var hear = el('button', { type: 'button', class: 'nkw-btn nkw-btn--ghost nkw-btn--sm', style: 'margin-bottom:12px' }, 'Hear it');
      hear.addEventListener('click', function () { if (!speak(target.sound)) ui.say('Sound is not available on this device. A grown-up can read it out.'); });
      play.appendChild(hear);
      var grid = el('div', { class: 'nkw-play__grid', style: '--cols:3' });
      pick.forEach(function (a) {
        var b = el('button', { type: 'button', class: 'nkw-tile', 'aria-label': a.name }, '<span aria-hidden="true">' + a.emoji + '</span><small>' + a.name + '</small>');
        b.addEventListener('click', function () {
          if (a === target) { flash(b, true); speak(a.sound); ui.win('Yes! The ' + a.name + ' says ' + a.sound + '.'); setTimeout(round, 1300); }
          else { flash(b, false); ui.say('The ' + a.name + ' says ' + a.sound + '. Try again!'); }
        });
        grid.appendChild(b);
      });
      play.appendChild(grid);
    }
    round();
  };

  GAMES['alphabet'] = function (play, ui) {
    play.innerHTML = '';
    var card = el('div', { class: 'nkw-play__row', style: 'justify-content:center;gap:16px;font:800 44px/1 var(--nkw-display)', 'aria-live': 'polite' }, '<span>Tap a letter</span>');
    play.appendChild(card);
    var grid = el('div', { class: 'nkw-play__grid', style: '--cols:7' });
    LETTERS.forEach(function (l) {
      var b = el('button', { type: 'button', class: 'nkw-tile', 'aria-label': l[0] + ' is for ' + l[1] }, l[0]);
      b.addEventListener('click', function () {
        card.innerHTML = '<span>' + l[0] + l[0].toLowerCase() + '</span><span aria-hidden="true">' + l[2] + '</span><span style="font-size:24px">' + l[0] + ' is for ' + l[1] + '</span>';
        speak(l[0] + ' is for ' + l[1]);
        ui.score(0);
      });
      grid.appendChild(b);
    });
    play.appendChild(grid);
  };

  GAMES['picture-puzzle'] = function (play, ui, opts) {
    var size = 3, img = opts.image;
    var order = shuffle([0, 1, 2, 3, 4, 5, 6, 7, 8]);
    if (order.every(function (v, i) { return v === i; })) order = [1, 0, 2, 3, 4, 5, 6, 7, 8];
    var first = null;
    play.innerHTML = '<p class="nkw-play__prompt">Tap two pieces to swap them</p>';
    var grid = el('div', { class: 'nkw-play__grid', style: '--cols:3;gap:4px;max-width:420px' });
    function draw() {
      grid.innerHTML = '';
      order.forEach(function (piece, slot) {
        var x = (piece % size) * 50, y = Math.floor(piece / size) * 50;
        var b = el('button', { type: 'button', class: 'nkw-tile', 'aria-label': 'Piece ' + (piece + 1) + ' in space ' + (slot + 1), style: 'border-radius:6px;background:#fff url(' + img + ') ' + x + '% ' + y + '% / 300% 300% no-repeat' });
        if (first === slot) b.style.boxShadow = 'inset 0 0 0 4px #EAB83D';
        b.addEventListener('click', function () {
          if (first === null) { first = slot; draw(); grid.children[slot].focus(); return; }
          var t = order[first]; order[first] = order[slot]; order[slot] = t; first = null; draw(); grid.children[slot].focus();
          if (order.every(function (v, i) { return v === i; })) ui.win('You finished the picture!');
          else ui.say('Swapped. Keep going!');
        });
        grid.appendChild(b);
      });
    }
    draw();
    play.appendChild(grid);
    var again = el('button', { type: 'button', class: 'nkw-btn nkw-btn--ghost nkw-btn--sm', style: 'margin-top:12px' }, 'Mix it up again');
    again.addEventListener('click', function () { GAMES['picture-puzzle'](play, ui, opts); });
    play.appendChild(again);
  };

  GAMES['odd-one-out'] = function (play, ui) {
    var keys = Object.keys(GROUPS);
    function round() {
      var two = sample(keys, 2), main = two[0], other = two[1];
      var odd = GROUPS[other][rand(GROUPS[other].length)];
      var items = shuffle(sample(GROUPS[main], 3).concat([odd]));
      play.innerHTML = '<p class="nkw-play__prompt">Which one does not belong?</p>';
      var grid = el('div', { class: 'nkw-play__grid' });
      items.forEach(function (it) {
        var b = el('button', { type: 'button', class: 'nkw-tile', 'aria-label': it === odd ? 'picture from ' + GROUP_NAMES[other] : 'picture from ' + GROUP_NAMES[main] }, '<span aria-hidden="true">' + it + '</span>');
        b.addEventListener('click', function () {
          if (it === odd) { flash(b, true); ui.win('Yes! The others are all ' + GROUP_NAMES[main] + '.'); setTimeout(round, 1100); }
          else { flash(b, false); ui.say('That one is ' + GROUP_NAMES[main] + ' like the others. Look again!'); }
        });
        grid.appendChild(b);
      });
      play.appendChild(grid);
    }
    round();
  };

  GAMES['pattern-builder'] = function (play, ui) {
    var pieces = [['circle', '#F2B49A'], ['square', '#9AA38C'], ['triangle', '#EAB83D'], ['star', '#4F86B0']];
    function round() {
      var unit = sample(pieces, 2 + rand(2));
      if (unit.length === 2 && Math.random() < 0.4) unit = [unit[0], unit[0], unit[1]];
      var seq = []; while (seq.length < 6) seq = seq.concat(unit);
      var shown = seq.slice(0, 5 + (unit.length === 3 ? 1 : 0)), answer = seq[shown.length] || unit[0];
      play.innerHTML = '<p class="nkw-play__prompt">What comes next?</p>';
      var row = el('div', { class: 'nkw-play__row', role: 'img', 'aria-label': 'Pattern: ' + shown.map(function (p) { return p[0]; }).join(', ') + ', then what?' });
      shown.forEach(function (p) { row.appendChild(el('span', { class: 'nkw-play__slot' }, shapeSvg(p[0], p[1]))); });
      row.appendChild(el('span', { class: 'nkw-play__slot nkw-play__slot--q' }, '?'));
      play.appendChild(row);
      var grid = el('div', { class: 'nkw-play__grid' });
      shuffle(pieces).forEach(function (p) {
        var b = el('button', { type: 'button', class: 'nkw-tile', 'aria-label': p[0] }, shapeSvg(p[0], p[1]));
        b.addEventListener('click', function () {
          if (p[0] === answer[0]) { flash(b, true); ui.win('Yes! The ' + p[0] + ' comes next.'); setTimeout(round, 1000); }
          else { flash(b, false); ui.say('Say the pattern out loud and try again.'); }
        });
        grid.appendChild(b);
      });
      play.appendChild(grid);
    }
    round();
  };

  GAMES['sequencing'] = function (play, ui) {
    function round() {
      var story = SEQUENCES[rand(SEQUENCES.length)], next = 0;
      play.innerHTML = '<p class="nkw-play__prompt">' + esc(story.title) + ': tap the pictures in order</p>';
      var row = el('div', { class: 'nkw-play__row', 'aria-label': 'Your order' });
      story.steps.forEach(function () { row.appendChild(el('span', { class: 'nkw-play__slot' }, '')); });
      play.appendChild(row);
      var grid = el('div', { class: 'nkw-play__grid' });
      shuffle(story.steps.map(function (s, i) { return { s: s, i: i }; })).forEach(function (it) {
        var b = el('button', { type: 'button', class: 'nkw-tile', 'aria-label': it.s[1] }, '<span aria-hidden="true">' + it.s[0] + '</span><small>' + esc(it.s[1]) + '</small>');
        b.addEventListener('click', function () {
          if (it.i === next) {
            row.children[next].innerHTML = '<span aria-hidden="true">' + it.s[0] + '</span>';
            b.disabled = true; b.classList.add('is-matched'); next++;
            if (next === story.steps.length) { ui.win('All in order! Well done.'); setTimeout(round, 1500); }
            else ui.say('Yes! What comes after ' + it.s[1].toLowerCase() + '?');
          } else { flash(b, false); ui.say('Not yet. What happens first?'); }
        });
        grid.appendChild(b);
      });
      play.appendChild(grid);
    }
    round();
  };

  /* ---------- launcher ---------- */
  function initGames(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-nkw-games]')).forEach(function (box) {
      if (box.__nkw) return; box.__nkw = true;
      var stage = box.querySelector('.nkw-stage');
      var title = stage.querySelector('[data-nkw-game-title]');
      var how = stage.querySelector('[data-nkw-game-how]');
      var play = stage.querySelector('.nkw-play');
      var status = stage.querySelector('[data-nkw-game-status]');
      var scoreEl = stage.querySelector('[data-nkw-game-score]');
      var image = box.getAttribute('data-image');
      var stars = 0;
      var ui = {
        say: function (msg) { status.textContent = msg; },
        win: function (msg) { stars++; scoreEl.textContent = '★ ' + stars; status.textContent = msg; },
        score: function () { /* exploring games have no score */ }
      };
      function start(btn) {
        var key = btn.getAttribute('data-game');
        if (!GAMES[key]) return;
        box.querySelectorAll('[data-game]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        stars = 0; scoreEl.textContent = '★ 0'; status.textContent = '';
        title.textContent = btn.getAttribute('data-title');
        how.textContent = btn.getAttribute('data-how');
        stage.hidden = false;
        GAMES[key](play, ui, { image: image });
      }
      box.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-game]');
        if (!btn) return;
        start(btn);
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        stage.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' });
        var focusable = play.querySelector('button');
        if (focusable) focusable.focus({ preventScroll: true });
      });
      var first = box.querySelector('[data-game]');
      if (first) start(first);
    });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initGames(document); });
    else initGames(document);
    document.addEventListener('shopify:section:load', function (e) { initGames(e.target); });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { GAMES: GAMES, initGames: initGames, shuffle: shuffle, LETTERS: LETTERS, SEQUENCES: SEQUENCES };
})();
